module.exports = "https://health.dajiuxing.com.cn/img/views/binding/img/step_03.jpg"


//////////////////
// WEBPACK FOOTER
// ./build/cdn-img-stub.js?path=views%2Fbinding%2Fimg%2Fstep_03.jpg
// module id = KTgm
// module chunks = 93